// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shortcuts{
     /* background: linear-(45deg, #3C8DBC, #2FD8ED); */
    background: #56CCF2;
    padding: 20px 10px;
    width: auto;
    color: #fff;
    border-radius: 1.5rem;
    text-align: center;
    margin: 0px 10px 10px 10px;
    max-width: 120px;
    height: 120px;
    box-shadow: 0 2rem 3rem rgb(132 139 200 / 52%);
    transition: 0.8s;
}
.shortcuts:hover{
    box-shadow: 0 2rem 3rem rgb(132 139 200 / 0%);
}
.shortcuts img {
    
    width: 60px;
    height: 60px;
}
.shortcuts div{
    font-size: 15px;
    font-weight: 700;
    margin-top: 6px;
}
.shotcuts-container{
    width: auto;
    min-width: 140px !important;
    padding: 0px;

}
.shotcuts-container a {
    display: block;
    width: 140px;
}

@media (max-width:576px) {
    .shortcuts{
        max-width: 100px;
        height: 100px;
        margin: 0px 0px 10px 0px ;
    }
    .shortcuts img {
        width: 45px;
        height: 45px;
    }
    .shortcuts div{
        font-size: 13px;
    }
    .shotcuts-container{
        min-width: 100px !important;    
    }
    .shotcuts-container a {
        width: 100px;
        margin-right: 6px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/componentsCss/ShortCuts.css"],"names":[],"mappings":"AAAA;KACK,kDAAkD;IACnD,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB,aAAa;IACb,8CAA8C;IAC9C,gBAAgB;AACpB;AACA;IACI,6CAA6C;AACjD;AACA;;IAEI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,2BAA2B;IAC3B,YAAY;;AAEhB;AACA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;QACb,yBAAyB;IAC7B;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":[".shortcuts{\n     /* background: linear-(45deg, #3C8DBC, #2FD8ED); */\n    background: #56CCF2;\n    padding: 20px 10px;\n    width: auto;\n    color: #fff;\n    border-radius: 1.5rem;\n    text-align: center;\n    margin: 0px 10px 10px 10px;\n    max-width: 120px;\n    height: 120px;\n    box-shadow: 0 2rem 3rem rgb(132 139 200 / 52%);\n    transition: 0.8s;\n}\n.shortcuts:hover{\n    box-shadow: 0 2rem 3rem rgb(132 139 200 / 0%);\n}\n.shortcuts img {\n    \n    width: 60px;\n    height: 60px;\n}\n.shortcuts div{\n    font-size: 15px;\n    font-weight: 700;\n    margin-top: 6px;\n}\n.shotcuts-container{\n    width: auto;\n    min-width: 140px !important;\n    padding: 0px;\n\n}\n.shotcuts-container a {\n    display: block;\n    width: 140px;\n}\n\n@media (max-width:576px) {\n    .shortcuts{\n        max-width: 100px;\n        height: 100px;\n        margin: 0px 0px 10px 0px ;\n    }\n    .shortcuts img {\n        width: 45px;\n        height: 45px;\n    }\n    .shortcuts div{\n        font-size: 13px;\n    }\n    .shotcuts-container{\n        min-width: 100px !important;    \n    }\n    .shotcuts-container a {\n        width: 100px;\n        margin-right: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
